// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__vTUKi","info":"Note_info__2zBVQ","note":"Note_note__2oxiW","actions":"Note_actions__24TUJ"};